<p-dialog header="Permalink to this case:" [(visible)]="displayPermalink" [position]="'topright'" (onHide)="hideDialog();" (onShow)="updatePermalink()" [dismissableMask]="true" [modal]="true">

    <div class="d-flex justify-content-between"> 
        <input type="text" class="mr-2" size="50" pInputText disabled [value]="permalinkText"/>
        <button class='primaryBtn  buttonWidth d-flex justify-content-between align-items-center w-50' pButton type="button" label="copy link" (click)="copyPermalink()">
            <mat-icon matTooltip="Share this case" class="copy">content_copy</mat-icon>
        </button>
    </div>
</p-dialog>
